"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _postmsgRpc = require("postmsg-rpc");

var _utils = require("identity-wallet/lib/utils");

var _idBlockchainUtils = require("3id-blockchain-utils");

var IdentityWallet = require('identity-wallet');

var ThreeId = require('3box/lib/3id/index');

var Url = require('url-parse');

var store = require('store');

var consentKey = function consentKey(address, domain, space) {
  return "3id_consent_".concat(address, "_").concat(domain, "_").concat(space);
};

var serializedKey = function serializedKey(address) {
  return "serialized3id_".concat(address);
}; // TODO ui/iframe needs number of hooks, events may be a better interface
// TODO could still refactor to make parts less visual/flow implementation specific

/**
 *  ThreeIdConnectService runs an identity wallet instance and rpc server with
 *  bindings to receive and relay rpc messages to identity wallet
 */


var ThreeIdConnectService =
/*#__PURE__*/
function () {
  /**
    * Create ThreeIdConnectService
    */
  function ThreeIdConnectService() {
    (0, _classCallCheck2.default)(this, ThreeIdConnectService);

    this._registerDisplayListeners();
  }
  /**
   * Registers rpc call function for display and hiding iframe (Note: reverse of
   * idw rpc calls, this is rpc client, sending messages to parent window)
   * @private
   */


  (0, _createClass2.default)(ThreeIdConnectService, [{
    key: "_registerDisplayListeners",
    value: function _registerDisplayListeners() {
      this.display = (0, _postmsgRpc.caller)('display', {
        postMessage: window.parent.postMessage.bind(window.parent)
      });
      this.hide = (0, _postmsgRpc.caller)('hide', {
        postMessage: window.parent.postMessage.bind(window.parent)
      });
    }
    /**
      *  External Authencation method for IDW
      *
      * @param     {Object}    params
      * @param     {String}    params.address     An ethereum address
      * @param     {Array}     params.spaces      Array of space strings
      * @param     {String}    params.type        Type of external auth request
      * @return    {Object}                       Response depends on type of request
    */

  }, {
    key: "externalAuth",
    value: function () {
      var _externalAuth = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref) {
        var address, spaces, type, threeId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                address = _ref.address, spaces = _ref.spaces, type = _ref.type;

                if (!(type === '3id_auth')) {
                  _context.next = 4;
                  break;
                }

                _context.next = 25;
                break;

              case 4:
                if (!(type === '3id_migration')) {
                  _context.next = 14;
                  break;
                }

                _context.next = 7;
                return this._getThreeId(address);

              case 7:
                threeId = _context.sent;

                if (!(spaces.length > 0)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return threeId.authenticate(spaces);

              case 11:
                return _context.abrupt("return", threeId.serializeState());

              case 14:
                if (!(type === '3id_createLink')) {
                  _context.next = 25;
                  break;
                }

                // TODO could use disply hook for a link request specific card, will show consent screen again right now
                this.displayIframe();
                _context.prev = 16;
                _context.next = 19;
                return this.idWallet.linkAddress(address, this.externalProvider);

              case 19:
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](16);
                console.log(_context.t0);

              case 24:
                this.hideIframe();

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[16, 21]]);
      }));

      function externalAuth(_x) {
        return _externalAuth.apply(this, arguments);
      }

      return externalAuth;
    }()
    /**
      *  Returns ThreeId instance, used for migration of legacy 3boxjs accounts
      *  to create same logic in iframe
      *
      * @private
      * @param     {String}    address     An ethereum address
      * @return    {ThreeId}
      */

  }, {
    key: "_getThreeId",
    value: function () {
      var _getThreeId2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(address) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.externalProvider) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this._connect(address);

              case 3:
                if (this._threeId) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 6;
                return ThreeId.getIdFromEthAddress(address, this.externalProvider, _utils.fakeIpfs, undefined, {});

              case 6:
                this._threeId = _context2.sent;

              case 7:
                return _context2.abrupt("return", this._threeId);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getThreeId(_x2) {
        return _getThreeId2.apply(this, arguments);
      }

      return _getThreeId;
    }()
    /**
      *  Tells parent window to display iframe
      */

  }, {
    key: "displayIframe",
    value: function () {
      var _displayIframe = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.display());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function displayIframe() {
        return _displayIframe.apply(this, arguments);
      }

      return displayIframe;
    }()
    /**
      *  Tells parent window to hide iframe
      */

  }, {
    key: "hideIframe",
    value: function () {
      var _hideIframe = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store.remove('error'); //TODO move, so specific to iframe implementation

                return _context4.abrupt("return", this.hide());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hideIframe() {
        return _hideIframe.apply(this, arguments);
      }

      return hideIframe;
    }()
    /**
      *  Removes cache consents. For partial migration in instance consent function
      *  returns, but external auth to support consents fails. Refactored in future.
      *
      * @private
      * @param     {Object}    message    IDW rpc request message
      * @param     {String}    domain     Origin of caller/request
      * @return    {ThreeId}
      */

  }, {
    key: "_removeConsents",
    value: function _removeConsents(message, domain) {
      var spaces = (0, _toConsumableArray2.default)(message.params.spaces);
      var rootKeys = store.get(serializedKey(message.params.address)); //TODO current root 'space', name

      if (!rootKeys) spaces.push('undefined');
      spaces.forEach(function (space) {
        var key = consentKey(message.params.address, domain, space);
        console.log(key);
        store.remove(key);
      });
    }
    /**
      *  Connect web3modal to get external provider
      *
      * @private
      * @param     {String}    address    Ethereum address of request
      * @param     {String}    domain     Origin of caller/request
      * @return    {ThreeId}
      */

  }, {
    key: "_connect",
    value: function () {
      var _connect2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(address, domain) {
        var providerName;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                providerName = store.get("provider_".concat(address)); //TODO ref to move this to iframe implementation specific

                if (providerName) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('Must select provider');

              case 3:
                _context5.next = 5;
                return this.web3Modal.connectTo(providerName);

              case 5:
                this.externalProvider = _context5.sent;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _connect(_x3, _x4) {
        return _connect2.apply(this, arguments);
      }

      return _connect;
    }() // TODO could consume web3modal or a provider already

    /**
      *  Start identity wallet service. Once returns ready to receive rpc requests
      *
      * @param     {Web3Modal}   web3Modal    configured instance of web3modal
      * @param     {Function}    getConsent   get consent function, reference IDW
      * @param     {Function}    erroCB       Function to handle errors, function consumes error string (err) => {...}, called on errors
      * @param     {Function}    cancel       Function to cancel request, consumes callback, which is called when request is cancelled (cb) => {...}
      */

  }, {
    key: "start",
    value: function start(web3Modal, getConsent, errorCb, cancel) {
      this.cancel = cancel;
      this.web3Modal = web3Modal;
      this.errorCb = errorCb;
      this.idWallet = new IdentityWallet(getConsent, {
        externalAuth: this.externalAuth.bind(this)
      });
      this.provider = this.idWallet.get3idProvider();
      (0, _postmsgRpc.expose)('send', this.providerRelay.bind(this), {
        postMessage: window.parent.postMessage.bind(window.parent)
      });
    }
    /**
      *  Consumes IDW RPC request message and relays to IDW instance. Also handles
      *  logic to retry requests and cancel requests.
      *
      * @param     {Object}      message    IDW RPC request message
      * @return    {String}                 response message string
      */

  }, {
    key: "providerRelay",
    value: function () {
      var _providerRelay = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(message) {
        var _this = this;

        var domain, loop, responsePromise;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                domain = new Url(document.referrer).hostname;
                loop = true;
                responsePromise = new Promise(
                /*#__PURE__*/
                function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee6(resolve, reject) {
                    var tries, res, _res;

                    return _regenerator.default.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            // Register request cancel calback
                            // TODO could make all rpc errors match spec
                            _this.cancel(function () {
                              var res = {
                                'id': message.id,
                                'json-rpc': '2.0',
                                error: "3id-connect: Request not authorized"
                              };
                              resolve(res);
                              loop = false;
                            }); // Should not be neccessary, but sets bounds on any uncaught errors, so
                            // we dont have infinite loop and freeze


                            tries = 0;

                            if (!(message.method === '3id_authenticate')) {
                              _context6.next = 23;
                              break;
                            }

                          case 3:
                            if (!loop) {
                              _context6.next = 21;
                              break;
                            }

                            tries++;
                            _context6.prev = 5;
                            _context6.next = 8;
                            return _this.provider.send(message, domain);

                          case 8:
                            res = _context6.sent;
                            if (message.method === "3id_authenticate") _this.hideIframe();
                            resolve(res);
                            loop = false;
                            _context6.next = 18;
                            break;

                          case 14:
                            _context6.prev = 14;
                            _context6.t0 = _context6["catch"](5);

                            _this.errorCb(_context6.t0, 'There was an error. Use the same account you used for this app.');

                            _this._removeConsents(message, domain);

                          case 18:
                            if (tries >= 10) loop = false;
                            _context6.next = 3;
                            break;

                          case 21:
                            _context6.next = 27;
                            break;

                          case 23:
                            _context6.next = 25;
                            return _this.provider.send(message, domain);

                          case 25:
                            _res = _context6.sent;
                            resolve(_res);

                          case 27:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, null, [[5, 14]]);
                  }));

                  return function (_x6, _x7) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _context7.t0 = JSON;
                _context7.next = 6;
                return responsePromise;

              case 6:
                _context7.t1 = _context7.sent;
                return _context7.abrupt("return", _context7.t0.stringify.call(_context7.t0, _context7.t1));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function providerRelay(_x5) {
        return _providerRelay.apply(this, arguments);
      }

      return providerRelay;
    }()
  }]);
  return ThreeIdConnectService;
}();

var _default = ThreeIdConnectService;
exports.default = _default;